import React from 'react';
import { Tooltip } from '@fluentui/react-components';

import CurrencyAmountComponent from '../../../commons/component/CurrencyAmount/CurrencyAmount.Component';

export interface ConsumptionAmountCellProps {
    amount: number;
    currency: string | undefined;
    /** Importe destacado (el que se liquida). */
    strong?: boolean;
    /** Aclaración del importe (de dónde sale); se muestra en un callout al pasar el mouse o enfocar el número. */
    detail?: string;
    testId?: string;
}

/**
 * Importe de una celda de la grilla de consumos con su aclaración en un callout.
 * La aclaración no va como segunda línea ni como ícono al lado: las filas tienen
 * alto fijo y las columnas de importes son angostas, así que cualquier cosa
 * extra se pisa con la fila o la columna vecina. El callout se abre sobre el
 * número mismo (mouse o foco de teclado) y se monta en un portal, así que no lo
 * recortan el scroll ni el apilamiento de la grilla. El clic en la celda sigue
 * abriendo el detalle del consumo, como en el resto de la fila.
 */
export const ConsumptionAmountCell: React.FC<ConsumptionAmountCellProps> = ({ amount, currency, strong, detail, testId }) => {
    const value = <CurrencyAmountComponent amount={amount} currency={currency} />;
    const content = strong ? <strong>{value}</strong> : value;
    if (!detail) {
        return (
            <span className="consumption-amount" data-testid={testId}>
                {content}
            </span>
        );
    }
    return (
        // "inaccessible": el texto accesible lo aporta el span de abajo; así Fluent no deja un nodo oculto por celda.
        <Tooltip content={detail} relationship="inaccessible" withArrow positioning="above">
            <span className="consumption-amount consumption-amount--detail" data-testid={testId} tabIndex={0}>
                {content}
                {/* Para lectores de pantalla y tests: el mismo texto del callout, sin ocupar lugar. */}
                <span className="consumption-amount__sr" data-testid={testId ? `${testId}-detail` : undefined}>
                    {detail}
                </span>
            </span>
        </Tooltip>
    );
};

export default ConsumptionAmountCell;
